import { useEffect, useState } from 'react'
import { api } from '../api'

interface OverviewData {
  cases: { total: number; published: number }
  reports: { total: number; published: number }
  leads: { cases: number; reports: number }
  views: { cases: number; reports: number }
}

export default function DashboardPage() {
  const [data, setData] = useState<OverviewData | null>(null)

  useEffect(() => {
    api.get('/api/admin/stats/overview').then((res) => {
      if (res.success) setData(res.data)
    })
  }, [])

  if (!data) return <div>加载中...</div>

  const cards = [
    { label: '案例总数', value: data.cases.total, sub: `已发布 ${data.cases.published}` },
    { label: '报告总数', value: data.reports.total, sub: `已发布 ${data.reports.published}` },
    { label: '案例线索', value: data.leads.cases, sub: '' },
    { label: '报告线索', value: data.leads.reports, sub: '' },
    { label: '案例浏览', value: data.views.cases, sub: '' },
    { label: '报告浏览', value: data.views.reports, sub: '' },
  ]

  return (
    <div>
      <div className="page-header">
        <h1 className="page-title">概览</h1>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))', gap: '16px' }}>
        {cards.map((card) => (
          <div key={card.label} style={{
            background: 'white',
            padding: '20px',
            borderRadius: '8px',
            boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
          }}>
            <div style={{ fontSize: '13px', color: 'var(--color-text-secondary)', marginBottom: '8px' }}>
              {card.label}
            </div>
            <div style={{ fontSize: '28px', fontWeight: 700 }}>{card.value}</div>
            {card.sub && (
              <div style={{ fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '4px' }}>
                {card.sub}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  )
}
